import {
  UnterminateEmployeeDocument,
  UnterminateEmployeeMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useUnterminateEmployee = () => {
  const [unterminateEmployee, { loading }] = useMutation(UnterminateEmployeeDocument, {
    extractorFn: (data) => data.employeesMutations.unterminateEmployeesEmployee,
  })

  const unterminate = async (variables: UnterminateEmployeeMutationVariables) => {
    const result = handleResult(await unterminateEmployee({ variables }), () => undefined)

    if (result?.success) {
      return {
        data: result.data,
        error: undefined,
      }
    } else {
      const error = result.errors[0]
      let message
      if (error && 'message' in error) {
        message = error.message
      }
      if (error && 'messages' in error) {
        message = error.messages[0]
      }
      return { data: undefined, error: message }
    }
  }
  return {
    loading,
    unterminate,
  }
}
